export default "__VITE_ASSET__c$IOIjRb__"